import Cookies from 'js-cookie';

export const testHeaderFooterPricingMenuItems = () => {
  window.testPricingMenuItems = () => {
    const headerMenu = document.querySelector(
      '[data-testid=header-wrapper] .website-header--inner-container ul'
    );
    const resourceLink = document.querySelector(
      '[data-testid=header-wrapper] .website-header--inner-container ul li[type=resource-menu]'
    );
    const resourcesMenu = document.querySelector('.footer-resources-menu');
    const resourcesFirstChild = document.querySelector('.footer-resources-menu a:first-of-type');
    let headerPricingLink = document.querySelector('li[type=simple-menu].i-nav-link--pricing');
    let footerPricingLink = document.querySelector(".footer-resources-menu a[href='/pricing']");

    if (headerMenu && resourcesMenu) {
      if (!headerPricingLink && !footerPricingLink) {
        headerPricingLink = resourceLink.cloneNode(true);
        headerPricingLink.setAttribute('type', 'simple-menu');
        headerPricingLink.classList.remove('has-child');
        headerPricingLink.textContent = '';

        const aTag = document.createElement('a');
        aTag.setAttribute('class', 'menu-item--parent-link i-nav-link--pricing');
        aTag.setAttribute('href', '/pricing');
        aTag.setAttribute('data-ol-has-click-handler', '');
        aTag.textContent = 'Pricing';
        headerPricingLink.appendChild(aTag);
        headerMenu.insertBefore(headerPricingLink, resourceLink);

        footerPricingLink = resourcesFirstChild.cloneNode(true);
        footerPricingLink.classList.add('i-nav-link--pricing');
        footerPricingLink.setAttribute('href', '/pricing');
        footerPricingLink.textContent = 'Pricing';
        resourcesMenu.insertBefore(footerPricingLink, resourcesFirstChild);
      }
    }
  };
};

export const testFeatureWheel = () => {
  window.testFeatureWheel = () => {
    const oldFeatureSection = document.querySelector('.home--feature-section-old');
    if (oldFeatureSection) {
      oldFeatureSection.style.display = 'none';
    }

    const newFeatureSection = document.querySelector('.home--feature-section-new');
    if (newFeatureSection) {
      newFeatureSection.style.display = 'block';
    }
  };
};

export const testDemo5 = () => {
  window.testDemo5 = () => {
    Cookies.set('demo_form_style_5', 'true');
  };
};

export const testSeePreview = () => {
  window.testSeePreview = () => {
    const origin = document.querySelector('.hero-contextual-cta--origin');
    const seePreview = document.querySelector('.hero-contextual-cta--see-preview');

    if (origin) {
      origin.style.display = 'none';
    }

    if (seePreview) {
      seePreview.style.display = 'block';
    }
  };
};
